import { useDispatch, useSelector } from 'react-redux';
import { selectAllWallet, selectUserCurrency } from 'redux/selectors';
import { useEffect } from 'react';
import { getWallets } from 'redux/wallets/walletsOperations';

export const Balance = data => {
  return data.reduce((acc, item) => acc + item.balance, 0);
};

export const DisplayBalance = () => {
  const dispatch = useDispatch();
  const allWallets = useSelector(selectAllWallet);
  const currencySymbol = useSelector(selectUserCurrency);
  useEffect(() => {
    dispatch(getWallets());
  }, [dispatch]);
  
  return (
    <div className="rounded-2xl bg-orange-50 px-4 py-2 font-brand text-base text-[#FF7601] md:text-lg">
      <span>
        {currencySymbol} {Balance(allWallets)}
      </span>
    </div>
  );
};
